import { render, staticRenderFns } from "./HelpDesksIssueFloating.vue?vue&type=template&id=390246cb&scoped=true"
import script from "./HelpDesksIssueFloating.vue?vue&type=script&lang=js"
export * from "./HelpDesksIssueFloating.vue?vue&type=script&lang=js"
import style0 from "./HelpDesksIssueFloating.vue?vue&type=style&index=0&id=390246cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390246cb",
  null
  
)

export default component.exports